import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import Payout from 'PMT/entities/Payout';

import PayoutsTableViewRow from './PayoutsTableViewRow';

export default class PayoutsTableView extends Component {

  static propTypes = {
    payouts: PropTypes.arrayOf(Payout),
    currencyCode: PropTypes.string,
  };

  render(): Object {
    let rows = [];

    const payouts = this.props.payouts;

    _.forEach(payouts, (payout: Payout) => {
      rows.push(
        <PayoutsTableViewRow
          payout={payout}
          key={payout.payoutId}
          currencyCode={this.props.currencyCode}
        />
      );
    });

    return (
      <div className="payins_table_view table_container table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>
                {I18n.tr('payouts.table.header.id')}
              </th>
              <th>
                {I18n.tr('payouts.table.header.reference')}
              </th>
              <th>
                {I18n.tr('payouts.table.header.date')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.amount')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.commissions_fixed_without_taxes')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.commissions_variable_without_taxes')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.vat')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.commissions_with_taxes')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.amount_net')}
              </th>
              <th
                className="text-center"
              >
                {I18n.tr('payouts.table.header.status')}
              </th>
            </tr>
          </thead>
          <tbody>
          {rows}
          </tbody>
        </table>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/payment/receipt/components/PayoutsTableView.js